import * as React from 'react';

const EmptyListMessage = ({ message }) => {
    return <div>{message}</div>
}

export { EmptyListMessage }


// WEBPACK FOOTER //
// ./src/components/EmptyListMessage.js